import { createContext } from "react";

export const ViewTypes = {
    Dashboard: '',
    EMail: 'mail',
    QRCode: 'share',
    Profile: 'profile',
    Friends: 'friends',
    VerseGuide: 'verse-guide',
    Ships: 'ships',
    IndustrialJobs: 'industrial-jobs',
    Squad: 'squad',
}

export interface iUser {
    uuid: string|undefined,
    name: string|undefined,
    data: {
        GameMasterFor: string|undefined
    }
}

export interface iGlobalSettingsContext {
    isFetching: boolean,
    // view: {section: string, id?: string},
    Mails: {
        new: boolean,
        readed: string[]
    },
    activeMission?: string,
    user: iUser,
    friends: {name: string, uuid: string}[],
    Actions: {
        Fetching: {
            start: (type: string) => void,
            stop: (type: string) => void,
        },
        setViewTo: ( view: string, id?: string ) => void,
        readEMail: (id: string) => void,
        ActiveMission: {
            set: (id: string) => void,
            delete: () => void
        }
        profile: {
            reset: () => void,
            generateUUID: () => void,
            setName: (name: string) => void
        },
        friends: {
            add: (name: string, uuid: string) => void,
            delete: (uuid: string) => void,
        }
    }
}

const defaultSettings = {
    isFetching: false,
    // view: {section: ViewTypes.ListOfEmails, id: undefined},
    Mails: {
        new: false,
        readed: []
    },
    activeMission: undefined,
    user: {
        uuid: undefined,
        name: undefined,
        data: {
            GameMasterFor: undefined
        }
    },
    friends: [],
    Actions: {
        Fetching: {
            start: () => {},
            stop: () => {},
        },
        setViewTo: () => {},
        readEMail: () => {},
        ActiveMission: {
            set: () => {},
            delete: () => {}
        },
        profile: {
            reset: () => {},
            generateUUID: () => {},
            setName: () => {}
        },
        friends: {
            add: (name: string, uuid: string) => {},
            delete: (uuid: string) => {},
        }
    }
};

export const GlobalSettingsContext = createContext<iGlobalSettingsContext>(defaultSettings);